module.exports = __webpack_public_path__ + "img/swine-site2-3.4e93ee9f.svg";